import { Card, CardContent, Stack } from "@altimateai/lego";
import { useState, useMemo } from "react";
import classNames from "classnames";
import { DebouncedInput } from "../../../components/form";
import styles from "../styles.module.scss";
import { Column } from "../types";
import { UserListResponse } from "@/types";
import ColumnCard from "./columnCard";

interface ColumnSectionProps {
  columns: Column[];
  users?: UserListResponse["users"];
  scope: string[];
  datastoreType: string;
}

export const ColumnSection = ({ columns, users, scope, datastoreType }: ColumnSectionProps) => {
  const [search, setSearch] = useState<string>("");
  const filteredColumns = useMemo(() => {
    if (!search) return columns;
    const _search = search.toLowerCase();
    return columns.filter(c => c.name.includes(_search));
  }, [columns, search]);

  return (
    <Card className={classNames(styles.column_section, "mb-0", styles.bg_gray)}>
      <CardContent className={classNames(styles.column_body, "al-flex al-flex-col gap-sm al-pt-4")}>
        <Stack justify="between" align="center" className="mb-1">
          <Stack justify="between" align="center" gap="sm">
            <div className="fs-5 fw-semibold">Columns</div>
            <div className={styles.searchBox}>
              <DebouncedInput
                size="sm"
                placeholder="Search Column"
                onChange={setSearch}
                aria-label={"Search Column"}
              />
            </div>
          </Stack>
          {search ? (
            <div className="text-primary">
              {filteredColumns.length} {filteredColumns.length === 1 ? "result" : "results"} found
            </div>
          ) : (
            <div>{columns.length} columns</div>
          )}
        </Stack>
        <div className={styles.grid}>
          <div className={styles.columnGrid}>
            {filteredColumns.map(c => (
              <ColumnCard
                key={c.table_schema_id}
                column={c}
                users={users}
                colDescription={c.description || ""}
                scope={scope}
                datastoreType={datastoreType}
              />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
